import { Controller, useForm } from "react-hook-form";
import { Column, Row, Spacer } from "../../../components/Layout/Layout";
import { EmergencyCenterSetting } from "../../../core/api/responsecenters/types";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import useTranslations from "../../../core/i18n/useTranslations";
import TextInput from "../../../ui-lib/components/Inputs/TextInput";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";
interface EditSettingDialogProps {
  settingsData?: EmergencyCenterSetting;
  saveButtonTitle: string;
  isOpen: boolean;
  onSubmit?: () => void;
  editSetting: (setting: EmergencyCenterSetting) => Promise<void>;
  closeModal: () => void;
}
export const EditEmergencyCenterSetting = ({
  settingsData,
  saveButtonTitle,
  isOpen,
  onSubmit,
  editSetting,
  closeModal,
}: EditSettingDialogProps) => {
  const t = useTranslations();

  const {
    control,
    formState: { isSubmitting, errors },
    handleSubmit,
  } = useForm<EmergencyCenterSetting>({
    defaultValues: settingsData,
  });

  const submit = async (data: EmergencyCenterSetting) => {
    try {
      data.id = settingsData?.id;
      await editSetting(data);
      onSubmit?.();
      closeModal();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      header={
        settingsData
          ? t("AlarmReceptions:edit_setting_title")
          : t("AlarmReceptions:add_setting_title")
      }
      onClose={closeModal}
      isOpen={isOpen}
      submitBtn={{ text: saveButtonTitle, onClick: handleSubmit(submit) }}
      cancelBtn={{ text: t("Common:cancel"), onClick: closeModal }}
      loading={isSubmitting}
      fixedWidth="848px"
    >
      <p>{t("AlarmReceptions:edit_emergencycenter_setting_description")}</p>
      <Spacer size={16} />
      <form className="mb-4">
        <Column type="top">
          <Row type="fill" align="fill" style={{ alignSelf: "stretch" }}>
            <Controller
              name="setting"
              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <TextInput
                  required
                  placeholder={t(
                    "AlarmReceptions:edit_emergencycenter_setting_placeholder_setting"
                  )}
                  label={t(
                    "AlarmReceptions:advanced_settings_emergencycentersettings_setting"
                  )}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  validationError={
                    errors.setting &&
                    t(
                      "AlarmReceptions:edit_emergencycenter_setting_validation_setting_required"
                    )
                  }
                />
              )}
            />
            <Spacer size={16} />
            <Controller
              name="value"
              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <TextInput
                  required
                  placeholder={t("Common:enter_value")}
                  label={t(
                    "AlarmReceptions:advanced_settings_emergencycentersettings_value"
                  )}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  validationError={
                    errors.value &&
                    t(
                      "AlarmReceptions:edit_emergencycenter_setting_validation_value_required"
                    )
                  }
                />
              )}
            />
          </Row>
        </Column>
      </form>
    </PrimeModal>
  );
};
